/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { ReactNode, useEffect, useRef, useState } from "react";
import { Box, SxProps, Theme } from "@mui/material";
import { useCarousel } from "./CarouselProvider";
import { mergeSx } from "../../utils/mergeSx";

export type CarouselSlideProps = {
  children: ReactNode;
  sx?: SxProps<Theme>;
};
export const CarouselSlide = ({ children, sx = [] }: CarouselSlideProps) => {
  const carouselSlide = useRef<HTMLElement>(null);
  const [isActive, setIsActive] = useState(false);
  const [slideIdx, setSlideIdx] = useState(0);

  const { carouselApi, id } = useCarousel();

  useEffect(() => {
    const handleChange = () => {
      const activeSlides = carouselApi?.slidesInView();
      const slideNoteIdx = carouselApi?.slideNodes().findIndex((ele) => ele === carouselSlide.current);

      setSlideIdx(slideNoteIdx ?? 0);
      setIsActive(Boolean(typeof slideNoteIdx === "number" && activeSlides?.includes(slideNoteIdx)));
    };

    carouselApi?.on("slidesInView", handleChange);
    carouselApi?.on("init", handleChange);
    carouselApi?.on("reInit", handleChange);

    handleChange();

    return () => {
      carouselApi?.off("slidesInView", handleChange);
      carouselApi?.off("init", handleChange);
      carouselApi?.off("reInit", handleChange);
    };
  }, [carouselApi]);

  return (
    <Box
      id={id + "slide" + slideIdx}
      ref={carouselSlide}
      // TODO: change to inert={!isActive} after react19 update
      {...(!isActive && { inert: true })}
      sx={mergeSx({ flexShrink: 0, flexGrow: 0, minWidth: 0 }, sx)}
    >
      {children}
    </Box>
  );
};
